<div class="row lay-out">
  <div class="col-sm-12 ">
    <router-outlet></router-outlet>
  </div>
</div>
<div *ngIf="loader" class="loader"><app-loader></app-loader></div>